<template>
    <div class="task-results">

        <div @click="clickOnShowDetailedTaskInfoIcon"
             class="task-result strong"
             v-tooltip.top="'Информация о задаче'">
            <i class="fa fa-info-circle icon"></i>
        </div>
        <dropdown-menu v-bind:task="task" @click-on-show-graph-icon="clickOnShowDrawIcon"/>

    </div>
</template>

<script>
import { TasksAPI } from 'api-client';
import DropdownMenu from "./DropdownMenu";

export default {
  name: "TaskResults",
  components: {
    DropdownMenu
  },
  props: ['task'],
  methods: {
    downloadTaskLink(task) {
      return TasksAPI.downloadResultRoute(task)
    },
    fullDownloadTaskLink(task) {
      return `http://${window.location.hostname}${this.downloadTaskLink(task)}`;
    },
    clickOnShowDrawIcon() {
      this.$emit('click-on-show-graph-icon', this.task.result.methodResult)
    },
    clickOnShowDetailedTaskInfoIcon() {
      this.$emit('click-on-show-detailed-task-info-icon', this.task)
    },
  }
}
</script>

<style scoped lang="sass">
    .task-result
        margin-right: gridSteps(1)

    .icon
        color: #636363
        text-align: center
        margin: 0 gridSteps(1) 0 gridSteps(1)
        width: 24px
        &:hover
            color: #5CA5D4
            cursor: pointer

    .graph-icon-wrapper
        position: relative
        top: 3px

</style>
